import { Grid, Typography } from "@mui/material";
import BaseTextField from "../../common/base-text-field/base-text-field";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { BaseButton } from "../../common/base-button/base-button";
import axios from "axios";
import BASE_URL from "../../../constants/baseUrls";
import { toast } from "react-toastify";
import { useState } from "react";

export function ContactForm({ endPoint }) {
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");
    const fields = [
        { id: 1, label: "نام", name: "firstName" },
        { id: 2, label: "نام خانوادگی", name: "lastName" },
        { id: 3, label: "شماره تماس", name: "phone" },
        { id: 4, label: "کد معرف", name: "referrerCode" },
    ];

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const registerOptions = {
        firstName: {
            required: `${t("firstName")} ${t("isRequired")}`,
            minLength: { value: 2, message: t("firstNameValidation1") },
            pattern: { value: /^[\u0600-\u06FF\s]+$/, message: t("firstNameValidation2") },
        },
        lastName: {
            required: `${t("firstName")} ${t("isRequired")}`,
            minLength: { value: 2, message: t("firstNameValidation1") },
            pattern: { value: /^[\u0600-\u06FF\s]+$/, message: t("firstNameValidation2") },
        },
        phone: {
            required: `${t("phoneNumberValidation4")}`,
            maxLength: { value: 11, message: `${t("phoneNumberValidation1")}` },
            minLength: { value: 11, message: `${t("phoneNumberValidation2")}` },
            pattern: { value: /^09\d{9}$/, message: `${t("phoneNumberValidation3")}` },
        },
    };

    const [isLoading, setIsLoading] = useState(false);
    const handleRegistration = async data => {
        const { firstName, lastName, phone, referrerCode } = data;
        const payload = {
            first_name: firstName,
            last_name: lastName,
            phone,
            referrer_code: referrerCode,
        };

        try {
            setIsLoading(true);
            const response = await axios.post(`${BASE_URL}${endPoint}`, payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });
            toast.success(response.data.message, { toastId: "custom-id-yes" });
        } catch (error) {
            const errorMessage = error.response.data.errors.detail[0];
            toast.error(errorMessage, { toastId: "custom-id-yes" });
        } finally {
            setIsLoading(false);
        }
    };
    const handleError = () => {};
    return (
        <Grid
            component="form"
            container
            md={4}
            flexDirection="column"
            rowGap={{ xs: 2, md: 4 }}
            bgcolor="var(--white-gray-color)"
            p={2}
            mt={{ xs: 0, md: 6 }}
            borderRadius={5}
            onSubmit={handleSubmit(handleRegistration, handleError)}
            position="sticky"
            top="5rem"
        >
            <Typography component="h3" color={"var(--primary-color)"} fontSize={{ xs: "1rem", md: "1.5rem" }} fontWeight="bold">
                فرم تماس
            </Typography>
            <Typography component="p" textAlign="justify" lineHeight="2rem" color={"var(--dark-gray)"} fontSize={{ xs: "0.875rem", md: "1rem" }}>
                متقاضی گرامی شما میتوانید کد تخفیف خود را در کادر زیر وارد کنید تا کارشناسان آتریپا جهت مشاوره تخصصی تحصیلی با شما تماس بگیرند و از
                خدمات رایگان ما بهره مند شوید.
            </Typography>

            {fields.map(field => (
                <BaseTextField
                    key={field.id}
                    label={field.label}
                    radius="10px"
                    name={field.name}
                    register={{
                        ...register(field.name, registerOptions?.[field.name]),
                    }}
                    error={errors?.[field.name]?.message}
                />
            ))}
            <BaseButton text={t("submit")} color="primary" size="large" radius="radius-10" loading={isLoading} />
        </Grid>
    );
}
